const EVENT_LOGS_ANCHOR_LOCAL_STORAGE_KEY = 'EventLogsEAnchor';

export { EVENT_LOGS_ANCHOR_LOCAL_STORAGE_KEY };
